/**
 * Guard and polyfill for console.errorNormalized.
 * Ensures runtime environments always have this helper available.
 * 
 * This is exported from @korvo/core so derivative apps can import it.
 */
import './console-error-normalized-polyfill.js';

declare global {
    interface Console {
        errorNormalized(message?: unknown, ...optionalParams: unknown[]): void;
    }
}

export {};

